import { PageLoadMetric } from '../metric/page-load-metric';
import { BMEventsType } from '../types';
import type { PageLoadPerformanceEventFactoryConfig } from './types';

export const pageLoad = (config: PageLoadPerformanceEventFactoryConfig): PageLoadMetric => {
	return new PageLoadMetric({ ...config, type: BMEventsType.PAGE_LOAD });
};
